export enum ApplicationFinalStage {
    SQL = 'SQL',
    CLOSED = 'Closed',
    FactFind = 'Fact Find',
}
